import React, { useState } from 'react';
import { graphql } from 'gatsby';
import { GatsbyImage, getImage } from 'gatsby-plugin-image';
import Close from '../assets/images/close.svg';
import Modal from 'react-modal';
import parse from 'html-react-parser'
import Slider from 'react-slick'

import Link from '../utils/link';
import Seo from '../components/seo';
import Map from '../components/map';
import Fade from 'react-reveal/Fade';
import RegisterYourInterest from '../components/register-your-interest';
import PageLinks from '../components/page-links';
import NextProject from '../components/next-project';

const carouselSettings = {
  arrows: true,
  dots: true,
}

const ProjectTemplate = (props) => {
  const [modalIsOpen, setIsOpen] = useState(false);
  const { wpProject, next } = props.data;

  const openModal = (e) => {
    e.preventDefault();
    setIsOpen(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setIsOpen(false);
  }

  return (
    <>
      <Seo {...wpProject.seo} bodyClass={'project-template'} />

      <section className="project-slider">
        <div className="project-slider__inner">
          <h1>{wpProject.title}</h1>

          <p>{wpProject.acf.tag}</p>

          <Slider {...carouselSettings}>
            {wpProject.acf.gallery?.map(({ localFile, altText }, index) => (
              <GatsbyImage image={getImage(localFile)} alt={altText} key={index} />
            ))}
          </Slider>

        </div>
      </section>

      <section className="project-details">
        <div className="project-details__inner">
          <div className="project-details__left">
            <h6>{wpProject.acf.intro}</h6>

            <Link onClick={openModal} className="btn btn--blue">
              {wpProject.acf.buttonText}
            </Link>

            <div className="project-details__item">
              <div className="title">
                <h4>STATUS</h4>
              </div>

              <div className="content">
                <p>{wpProject.acf.status}</p>
              </div>
            </div>

            <div className="project-details__item">
              <div className="title">
                <h4>Offering</h4>
              </div>

              <div className="content">
                <p>{wpProject.acf.type}</p>
              </div>
            </div>

            <div className="project-details__item">
              <div className="title">
                <h4>LOCATION</h4>
              </div>

              <div className="content">
                <p>{wpProject.acf.location}</p>
              </div>
            </div>

            <div className="project-details__item">
              <div className="title">
                <h4>TEAM</h4>
              </div>

              <div className="content">
                {wpProject.acf.team.map(({ link, text }, index) => (
                  <Link to={link} key={index}>{text}</Link>
                ))}
              </div>
            </div>
          </div>

          <div className="project-details__right">
            { wpProject.acf.about.image?.localFile && <GatsbyImage image={getImage(wpProject.acf.about.image?.localFile)} alt={wpProject.acf.about.image?.altText} /> }

            <h5>{wpProject.acf.about.title}</h5>

            { wpProject.acf.about?.content && <div>{parse(wpProject.acf.about.content)}</div> }
          </div>
        </div>
      </section>

      <section className="project-image">
        <div className="project-image__inner">
          <Slider {...carouselSettings}>
            {wpProject.acf.innerGallery?.map(({ localFile, altText }, index) => (
              <GatsbyImage image={getImage(localFile)} alt={altText} key={index} />
            ))}
          </Slider>
        </div>
      </section>

      <section className="project-quote">
        <div className="project-quote__inner">
          { wpProject.acf.quote?.content && <div>{parse(wpProject.acf.quote.content)}</div> }
          <h4>{wpProject.acf.name}</h4>
          <span>{wpProject.acf.position}</span>
        </div>
      </section>

      <section className="project-map contact-map">
        <div className="project-map__inner contact-map__inner">
          <Fade>
            <Map lat={wpProject.acf.googleMap.latitude} lng={wpProject.acf.googleMap.longitude} />
          </Fade>
        </div>
      </section>

      <RegisterYourInterest title={wpProject.title} />

      <PageLinks />

      <NextProject {...next} />

      <div className={`overlay${modalIsOpen ? ' active' : ''}`}>
        <div className='overlay__wrapper'>
          <button onClick={closeModal} className="form--close"><img src={Close} alt="Close" /></button>
          <RegisterYourInterest title={wpProject.title} extraClass="form--modal" />
        </div>
      </div>
    </>
  );
};

export const pageQuery = graphql`
  query ($id: String, $next: String) {
    wpProject(id: {eq: $id}) {
      title
      slug
      uri
      seo {
        ...WpSeo
      }
      acf {
        about {
          content
          title
          image {
            altText
            localFile {
              publicURL
              childImageSharp {
                gatsbyImageData(
                  width: 1000
                )
              }
            }
          }
        }
        buttonText
        contact {
          name
          email {
            title
            url
          }
          phone {
            target
            url
          }
        }
        intro
        quote {
          content
          name
          position
        }
        status
        type
        location
        tag
        team {
          link
          text
        }
        googleMap {
          latitude
          longitude
        }
        gallery {
          altText
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1400
              )
            }
          }
        }
        innerGallery {
          altText
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1400
              )
            }
          }
        }
      }
    }
    next: wpProject(id: {eq: $next}) {
      uri
      title
      acf {
        tag
        gallery {
          localFile {
            publicURL
            childImageSharp {
              gatsbyImageData(
                width: 1400
              )
            }
          }
        }
      }
    }
  }
`;

export default ProjectTemplate;